import { render } from "./AppMessages.vue?vue&type=template&id=6c57401c"
import script from "./AppMessages.vue?vue&type=script&lang=js"
export * from "./AppMessages.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__